import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Login & Signup/login.css';

const SignupForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    usermail: '',
    pass1: '',
    pass2: '',
  });

  const [errors, setErrors] = useState({});

  const submitHandler = (e) => {
    e.preventDefault();

    let errors = {};

    if (formData.username.trim() === '') {
      errors.username = 'Username Required!';
    } else if (formData.username.trim().length < 5) {
      errors.username = 'Username Must be 5 Chars or More!';
    }

    if (formData.usermail.trim() === '') {
      errors.usermail = 'User Mail Required!';
    } else if (!formData.usermail.includes('@')) {
      errors.usermail = "Email must contain '@' symbol";
    }

    if (formData.pass1.trim() === '') {
      errors.pass1 = 'Password is Required';
    } else if (formData.pass1.trim().length < 8) {
      errors.pass1 = 'Password should contain at least 8 characters!';
    }

    if (formData.pass2.trim() === '') {
      errors.pass2 = 'Confirm Password is Required';
    } else if (formData.pass1 !== formData.pass2) {
      errors.pass2 = 'Passwords do not match';
    }

    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      // No errors, proceed to navigate
      navigate('/checkout');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    
    <div className="auth-container" id='card2'>
      <div className="container">
        <h2>Signup</h2>
        <form onSubmit={submitHandler} className="w-100">
          <input
            type="text"
            placeholder="Enter username"
            name="username"
            onChange={handleChange}
            value={formData.username}
          />
          {errors.username && <p className="error-color">{errors.username}</p>}

          <input
            type="text"
            placeholder="Enter email"
            name="usermail"
            onChange={handleChange}
            value={formData.usermail}
          />
          {errors.usermail && <p className="error-color">{errors.usermail}</p>}

          <input
            type="password"
            placeholder="Password"
            name="pass1"
            onChange={handleChange}
            value={formData.pass1}
          />
          {errors.pass1 && <p className="error-color">{errors.pass1}</p>}

          <input
            type="password"
            placeholder="Confirm password"
            name="pass2"
            onChange={handleChange}
            value={formData.pass2}
          />
          {errors.pass2 && <p className="error-color">{errors.pass2}</p>}

          <button type="submit">Submit</button>
        </form>

        <div className="footer">
          <p>Already Have an Account...?</p>
          <Link to="/login" style={{textDecoration : 'none'}}>Login</Link>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
